/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MilestoneNotificationAction } from './MilestoneNotificationAction';
import {
    MilestoneNotificationActionFromJSON,
    MilestoneNotificationActionFromJSONTyped,
    MilestoneNotificationActionToJSON,
} from './MilestoneNotificationAction';

/**
 * 
 * @export
 * @interface MilestoneNotification
 */
export interface MilestoneNotification {
    /**
     * 
     * @type {string}
     * @memberof MilestoneNotification
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneNotification
     */
    groupId: string;
    /**
     * 
     * @type {boolean}
     * @memberof MilestoneNotification
     */
    isSeen: boolean;
    /**
     * 
     * @type {number}
     * @memberof MilestoneNotification
     */
    seenAt?: number;
    /**
     * 
     * @type {Array<MilestoneNotificationAction>}
     * @memberof MilestoneNotification
     */
    actions: Array<MilestoneNotificationAction>;
}

/**
 * Check if a given object implements the MilestoneNotification interface.
 */
export function instanceOfMilestoneNotification(value: object): value is MilestoneNotification {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "groupId" in value && value["groupId"] !== undefined;
    isInstance = isInstance && "isSeen" in value && value["isSeen"] !== undefined;
    isInstance = isInstance && "actions" in value && value["actions"] !== undefined;

    return isInstance;
}

export function MilestoneNotificationFromJSON(json: any): MilestoneNotification {
    return MilestoneNotificationFromJSONTyped(json, false);
}

export function MilestoneNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): MilestoneNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'groupId': json['group_id'],
        'isSeen': json['is_seen'],
        'seenAt': !exists(json, 'seen_at') ? undefined : json['seen_at'],
        'actions': ((json['actions'] as Array<any>).map(MilestoneNotificationActionFromJSON)),
    };
}

export function MilestoneNotificationToJSON(value?: MilestoneNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'group_id': value.groupId,
        'is_seen': value.isSeen,
        'seen_at': value.seenAt,
        'actions': ((value.actions as Array<any>).map(MilestoneNotificationActionToJSON)),
    };
}

